"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@/config/utils");
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'CommaNumber',
    props: {
        data: {
            type: Number,
            required: true
        },
        color: {
            type: String,
            required: false
        },
        decimal: {
            type: Boolean,
            required: false,
            default: false
        },
        comma: {
            type: String,
            required: false,
            default: ','
        },
        format: {
            type: Function,
            required: false,
            default: undefined
        }
    },
    data() {
        return {};
    },
    computed: {
        currentClass() {
            if (this.color) {
                return 'local-main-color-' + this.color;
            }
            else {
                return '';
            }
        },
        currentData() {
            return (0, utils_1.parseNumberByComma)(this.data, this.comma, this.decimal);
        }
    }
});
